<template>
	<el-dialog title="实名认证" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
		<el-form ref="form" :model="form" label-width="100px" label-position="left">
			<el-form-item label="姓名" :rules="[{ required: true} ]">
				<el-input v-model="form.name" placeholder="请输入姓名"></el-input>
			</el-form-item>
			<el-form-item label="身份证号码" :rules="[{ required: true} ]">
				<el-input v-model="form.idCard" placeholder="请输入身份证号码"></el-input>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<div class="flex align-center justify-center">
				<div class="flex align-center">
					<div class="" style="margin-right: 20px;">
						<el-button @click="handleClose">取 消</el-button>
					</div>
					<el-button type="primary" @click="handleSubmit">确 定</el-button>
				</div>
			</div>
			
		</span>
	</el-dialog>
</template>

<script>
	import {
		gatheringMeetingAuthFlowOneStep,
		getPsnAuthUrl
	} from '@/serve/live';

	export default {
		props: {
			dialogVisible: Boolean,
			meetingId: String
		},
		data() {
			return {
				form: {}
			}
		},
		methods: {
			handleClose() {
				this.$emit('close')
			},
			handleSubmit() {
				const {
					idCard,
					name
				} = this.form
				if (!name) {
					this.$message.warning('请填写姓名');
					return
				}
				if (!idCard) {
					this.$message.warning('请填写身份证');
					return
				}
				
				getPsnAuthUrl({
					idCard,
					meetingId: this.meetingId,
					name,
					isPc:true,
				}).then(res => {
					window.location.href = res.authUrl
				}).catch(err => {
					this.$message.error(err.data.message);
				});
				// gatheringMeetingAuthFlowOneStep({
				// 	idCard,
				// 	meetingId: this.meetingId,
				// 	name,
				// 	isPc:true,
				// }).then(res => {
				// 	window.location.href = res.longUrl
				// }).catch(err => {
				// 	this.$message.error(err.data.message);
				// });
			}
		}
	}
</script>
